import { useCallback } from 'react'
import usePresenceChannel, {
  PresencePayload,
  PresenceViewer as Viewer,
} from 'app/frontend/base/hooks/usePresenceChannel'

type Options = {
  eventId?: number
  onEventUpdated?: (event: wowaudit.Event) => void
}

type EventChannelPayload = PresencePayload & {
  event?: wowaudit.Event
}

const useEventChannel = ({ eventId, onEventUpdated }: Options) => {
  const handlePayload = useCallback(
    (payload: EventChannelPayload) => {
      if (payload.type === 'event_updated' && payload.event) {
        onEventUpdated?.(payload.event)
      }
    },
    [onEventUpdated],
  )

  const { viewers, requiresReload } = usePresenceChannel<EventChannelPayload>({
    channelName: 'EventChannel',
    channelId: eventId,
    channelIdParam: 'event_id',
    onPayload: handlePayload,
  })

  return {
    viewers,
    requiresReload,
  }
}

export type { Viewer }
export default useEventChannel
